var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"banner",staticClass:"aside-banner",class:_vm.bannerClass},_vm._l((_vm.banners),function(banner,index){return _c('div',{key:index,staticClass:"aside-banner__item"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(banner.logo),expression:"banner.logo"}],on:{"click":function($event){return _vm.openDetail(banner)}}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }